angular.module('natgeo').controller('Level5BuildScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'UserProgress', 'CommonFunctions',
function Level5BuildScreen($scope, element, ScreenFactory, manager, container, UserProgress, CommonFunctions)
{
	var screen = ScreenFactory( 'level5_build', element );
	
	// Before we transition into this screen, set it up.
	screen.on('introBefore', function()
	{
		screen._begin.addClass('hidden');

		UserProgress.ExplorerRetrieval = null;
		UserProgress.ExplorerLight = null;

		if ( !$scope.$$phase )
		{
			$scope.$apply();
		}
	});

	// Displays the Begin button when applicable.
	screen.updateBegin = function()
	{
		if ( UserProgress.ExplorerRetrieval !== null && 
			   UserProgress.ExplorerLight !== null &&
			   screen._begin.hasClass('hidden') )
		{
			screen.introduce( 'begin', 'slideInDownRight' );
		}
	}

	// Get & Set Retrieval & Light Functions
	$scope.setRetrieval = function(nm)
	{
		UserProgress.ExplorerRetrieval = UserProgress.ExplorerRetrievals[ nm ];

		screen.updateBegin();
	}

	$scope.isRetrieval = function(nm)
	{
		return UserProgress.ExplorerRetrieval === UserProgress.ExplorerRetrievals[ nm ];
	};
	
	$scope.setLight = function(nm)
	{
		UserProgress.ExplorerLight = UserProgress.ExplorerLights[ nm ];

		screen.updateBegin();
	}

	$scope.isLight = function(nm)
	{
		return UserProgress.ExplorerLight === UserProgress.ExplorerLights[ nm ];
	};

	// Help Dialog
	$scope.help = CommonFunctions.help( screen );

	// Test!
	$scope.begin = function()
	{
		manager.transition('level5_test');	
	};
	
	// The previous screen is the plan screen
	$scope.prev = function()
	{
		manager.transition('level5_plan');
	};
	
}]);